import { useSelector } from "react-redux";

import { RootState } from "@/store/store";
import ageCalculator from "@/utils/agecalculator";
import formattedDate from "@/utils/formattedDate";
import pfoneFormatter from "@/utils/pfoneFormatter";
import DescriptionDetailsList from "@/shared/components/DescriptionDetailsList/DescriptionDetailsList";
import useGetRole from "@/hooks/useGetRole";

import { ISelectedpatientProps } from "@/shared/interfaces/patientPage";

import "./PatientDetailsPageUserInfo.scss";

export default function PatientDetailsPageUserInfo({
    toggleDrawer,
}: ISelectedpatientProps) {
    const selectedPatient = useSelector(
        (state: RootState) => state.patients.selectedPatient,
    );
    const { isAdmin } = useGetRole();
    const {
        gender,
        dateOfBirth,
        secondaryPhones,
        email,
        adress,
        primaryPhone,
    } = selectedPatient;

    return (
        <section className='user_info_container'>
            <div className='section_info'>
                <DescriptionDetailsList
                    title={"Стать"}
                    description={
                        gender
                            ? gender === "male"
                                ? "Чоловіча"
                                : "Жіноча"
                            : ""
                    }
                    style={{ maxWidth: 194 }}
                />
                <DescriptionDetailsList
                    title={"Дата народження"}
                    description={dateOfBirth ? formattedDate(dateOfBirth) : ""}
                    style={{ maxWidth: 194 }}
                />
                <DescriptionDetailsList
                    title={"Вік"}
                    description={dateOfBirth ? ageCalculator(dateOfBirth) : ""}
                    style={{ maxWidth: 194 }}
                />
            </div>
            <div className='section_info'>
                <DescriptionDetailsList
                    title={"Основний телефон"}
                    description={
                        dateOfBirth ? pfoneFormatter(primaryPhone) : ""
                    }
                    style={{ maxWidth: 194 }}
                />
                {secondaryPhones &&
                    secondaryPhones.length > 0 &&
                    secondaryPhones.map((phone, index) => (
                        <DescriptionDetailsList
                            key={phone._id}
                            title={phone.type}
                            description={
                                phone.number ? pfoneFormatter(phone.number) : ""
                            }
                            style={{ maxWidth: 194 }}
                        />
                    ))}
            </div>
            <div className='section_info'>
                <DescriptionDetailsList
                    title={"Електронна пошта"}
                    description={email ? email : ""}
                    style={{ maxWidth: 194 }}
                />
            </div>
            <div className='section_info email'>
                <DescriptionDetailsList
                    title={"Адреса"}
                    description={adress ? adress : ""}
                />
                <DescriptionDetailsList
                    title={"Додаткова Інформація"}
                    description={email ? email : ""}
                />
            </div>
            {isAdmin ? (
                <button
                    className='user_info_button edit_button'
                    onClick={() => toggleDrawer(true)}
                >
                    <img
                        src='/patientdetailspage/edit_intarective.svg'
                        alt='logo edit'
                    />
                    Редагувати
                </button>
            ) : null}
        </section>
    );
}
